export default __webpack_public_path__ + "alberta-website.7b869461937dd6a34ee8.svg";